export const DE_PSEUDO_CARE_PROVIDER_FAILURE = 'DE_PSEUDO_CARE_PROVIDER_FAILURE';

export const dePseudoCareProviderFailure = error => ({
    type: DE_PSEUDO_CARE_PROVIDER_FAILURE,
    payload: error,
    error: true,
});
